import { Box } from '@mui/material';

import { IncidentCodeDataGrid } from './components/IncidentCodeDataGrid';

const IncidentCodesPage = () => {
  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          flexGrow: 1,
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        <IncidentCodeDataGrid />
      </Box>
    </Box>
  );
};

export default IncidentCodesPage;
